import PurchaseAmount from 'features/payLater/screens/PurchaseAmount/PurchaseAmount';

export default function Page() {
  return <PurchaseAmount />;
}
